var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "reveal-scope" },
    [
      _c(
        "header",
        { staticClass: "rs-header" },
        [_vm._m(0), _c("ScopeMenuBar", { on: { action: _vm.onMenuAction } })],
        1
      ),
      _c(
        "div",
        { staticClass: "rs-stage" },
        [
          _vm.activeModule === "evaluate"
            ? [
                _c("div", { staticClass: "scp-hyp-card" }, [
                  _c("div", { staticClass: "scp-hyp-head" }, [
                    _c("span", { staticClass: "scp-hyp-title" }, [
                      _vm._v("Hypothesis"),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "scp-hyp-edit",
                        attrs: { type: "button" },
                        on: { click: _vm.onEditHypothesis },
                      },
                      [_vm._v("Edit")]
                    ),
                  ]),
                  _c("p", { staticClass: "scp-hyp-text" }, [
                    _vm._v(_vm._s(_vm.activeHypothesisText)),
                  ]),
                ]),
                _vm.showContentTabs
                  ? _c(
                      "div",
                      {
                        staticClass: "scp-module-tabs",
                        attrs: {
                          role: "tablist",
                          "aria-label": "Module content",
                        },
                      },
                      [
                        _vm.showEvaluationTab
                          ? _c(
                              "button",
                              {
                                staticClass: "scp-module-tab",
                                class: {
                                  "is-active":
                                    _vm.evaluateContentTab === "evaluation",
                                },
                                attrs: {
                                  type: "button",
                                  role: "tab",
                                  "aria-selected":
                                    _vm.evaluateContentTab === "evaluation"
                                      ? "true"
                                      : "false",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.evaluateContentTab = "evaluation"
                                  },
                                },
                              },
                              [_vm._v(" Evaluation ")]
                            )
                          : _vm._e(),
                        _vm.hasKgContent
                          ? _c(
                              "button",
                              {
                                staticClass: "scp-module-tab",
                                class: {
                                  "is-active": _vm.evaluateContentTab === "kg",
                                },
                                attrs: {
                                  type: "button",
                                  role: "tab",
                                  "aria-selected":
                                    _vm.evaluateContentTab === "kg"
                                      ? "true"
                                      : "false",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.evaluateContentTab = "kg"
                                  },
                                },
                              },
                              [_vm._v(" CFDE KG ")]
                            )
                          : _vm._e(),
                        _vm.hasBiomarkerContent
                          ? _c(
                              "button",
                              {
                                staticClass: "scp-module-tab",
                                class: {
                                  "is-active":
                                    _vm.evaluateContentTab === "biomarker",
                                },
                                attrs: {
                                  type: "button",
                                  role: "tab",
                                  "aria-selected":
                                    _vm.evaluateContentTab === "biomarker"
                                      ? "true"
                                      : "false",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.evaluateContentTab = "biomarker"
                                  },
                                },
                              },
                              [_vm._v(" Biomarker KB ")]
                            )
                          : _vm._e(),
                        _vm.hasLiteratureContent
                          ? _c(
                              "button",
                              {
                                staticClass: "scp-module-tab",
                                class: {
                                  "is-active":
                                    _vm.evaluateContentTab === "explore",
                                },
                                attrs: {
                                  type: "button",
                                  role: "tab",
                                  "aria-selected":
                                    _vm.evaluateContentTab === "explore"
                                      ? "true"
                                      : "false",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.evaluateContentTab = "explore"
                                  },
                                },
                              },
                              [_vm._v(" Explore options ")]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.showEvaluationTab
                  ? _c("ScopeEvaluationPanel", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.showContentTabs ||
                            _vm.evaluateContentTab === "evaluation",
                          expression:
                            "!showContentTabs || evaluateContentTab === 'evaluation'",
                        },
                      ],
                      attrs: {
                        "hypothesis-text": _vm.activeHypothesisText,
                        "preloaded-evaluation": _vm.pendingImportedEvaluation,
                      },
                      on: {
                        evaluated: _vm.onEvaluated,
                        loading: _vm.onEvaluateLoading,
                      },
                    })
                  : _vm._e(),
                _vm.hasKgContent
                  ? _c("ScopeKgEvidenceTable", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.evaluateContentTab === "kg",
                          expression: "evaluateContentTab === 'kg'",
                        },
                      ],
                      attrs: {
                        evidence: _vm.kgEvidence,
                        "blocked-reason": _vm.kgEvidenceBlockedReason,
                        "relevance-loading": _vm.kgRelevanceLoading,
                        "network-graph": _vm.kgNetworkGraph,
                      },
                    })
                  : _vm._e(),
                _vm.hasBiomarkerContent
                  ? _c("ScopeBiomarkerEvidenceTable", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.evaluateContentTab === "biomarker",
                          expression: "evaluateContentTab === 'biomarker'",
                        },
                      ],
                      attrs: {
                        evidence: _vm.biomarkerEvidence,
                        "blocked-reason": _vm.biomarkerEvidenceBlockedReason,
                        "relevance-loading": _vm.biomarkerRelevanceLoading,
                      },
                    })
                  : _vm._e(),
                _vm.hasLiteratureContent
                  ? _c("ScopeLiteratureLauncher", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.showContentTabs ||
                            _vm.evaluateContentTab === "explore",
                          expression:
                            "!showContentTabs || evaluateContentTab === 'explore'",
                        },
                      ],
                      attrs: {
                        "hypothesis-text": _vm.activeHypothesisText,
                        "preloaded-query": _vm.pendingImportedLiteratureQuery,
                      },
                      on: {
                        "query-change": _vm.onLiteratureQueryChange,
                        loading: _vm.onLiteratureLoading,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.showActionsPanel
            ? _c("ScopeActionsPanel", {
                attrs: {
                  "next-steps": _vm.nextStepActions,
                  "catalog-actions": _vm.catalogActions,
                  "initial-tab": _vm.actionsPanelInitialTab,
                },
                on: {
                  run: _vm.onRunSuggestedAction,
                  close: _vm.onCloseActionsPanel,
                },
              })
            : _vm._e(),
          _c("ScopeProgressOverlay", {
            attrs: { open: _vm.progressOverlayOpen, steps: _vm.progressSteps },
          }),
        ],
        2
      ),
      _c("input", {
        ref: "importFileInput",
        staticClass: "rs-import-input",
        attrs: { type: "file", accept: "application/json" },
        on: { change: _vm.onImportFileChange },
      }),
      _c("ScopeWelcomePanel", {
        attrs: {
          open: _vm.welcomeOpen,
          "initial-tab": _vm.welcomeInitialTab,
          "initial-hypothesis-text": _vm.welcomeInitialHypothesisText,
          dismissible: _vm.hasGeneratedContent,
        },
        on: {
          "select-option": _vm.onWelcomeSelectOption,
          "import-session": _vm.triggerImport,
          close: function ($event) {
            _vm.welcomeOpen = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rs-brand" }, [
      _c("span", { staticClass: "rs-mark" }, [_vm._v("REVEAL")]),
      _c("span", { staticClass: "rs-title" }, [_vm._v("SCOPE")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }